import React, { useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { localApi, inshaApi } from "utils/imgApi";
import { produce } from "immer";
import { childListApi } from "views/Pages/Child.js";
import AddIcon from "@material-ui/icons/Add";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Check from "@material-ui/icons/Check";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import style from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
import styleSweet from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import styleCheck from "assets/jss/material-dashboard-pro-react/views/registerPageStyle";
import axios from "axios";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField, Chip } from "@material-ui/core";

import { credentials } from "utils/imgApi";
import { parentListApi } from "views/Pages/Parent.js";

const useStyles = makeStyles(styles);
const useStyle = makeStyles(style);
const useStyleSweet = makeStyles(styleSweet);
const useStyCheck = makeStyles(styleCheck);

export default function AddLabourRate(props) {
  const [items, setItems] = React.useState([]);
  const [items1, setItems1] = React.useState([]);
  const [items2, setItems2] = React.useState([]);
  const [simpleSelect, setSimpleSelect] = React.useState("");
  const [simpleSelectErr, setSimpleSelectErr] = React.useState("");
  const [simpleSelect1, setSimpleSelect1] = React.useState("");
  const [simpleSelect1Err, setSimpleSelect1Err] = React.useState("");
  const [labourDetails, setLabourDetails] = React.useState("");
  const [labourErr, setLabourErr] = React.useState("");
  const [hsnCode, setHsnCode] = React.useState("");
  const [hsnCodeErr, setHsnCodeErr] = React.useState("");
  const [price, setPrice] = React.useState("");
  const [priceErr, setPriceErr] = React.useState("");
  const [gst, setGst] = React.useState("");
  const [gstErr, setGstErr] = React.useState("");
  const [getId, setGetId] = React.useState("");
  const [getcatId, setGetcatId] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);
  const [alertType, alertTypeOps] = React.useState("");
  const [alertMsg, alertMsgOps] = React.useState("");

  const [newChild, setNewChild] = React.useState(false);
  const [btn, setBtn] = React.useState(false);

  const [active, setActive] = React.useState(false);
  const firstRender = useRef(true);
  const [multipleSelect, setMultipleSelect] = React.useState([]);
  const [newDefChild, setNewDefChild] = React.useState(false);
  const [multipleSelectErr, setMultipleSelectErr] = React.useState("");

  const classes = useStyles();
  const classe = useStyle();
  const classSweet = useStyleSweet();
  const classCheck = useStyCheck();

  const adminObj = JSON.parse(sessionStorage.getItem("sessionData"));

  async function getUsers() {
    const api =
      localApi + `/category/list/byAdminId/${adminObj && adminObj.id}`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    setItems(getResult && getResult);
    // console.log(getResult);
  }

  useEffect(() => {
    getUsers();
  }, []);

  const handleSimple = async (event) => {
    // setSimpleSelect(event.target.value);
    const { value } = event.target;
    const item = items.find((item) => item.id == value);
    setSimpleSelect(value);
    setGetId(item.id);
    const response = await axios.get(
      localApi + `/parent/list/byCategoryId/${item.id}`,
      {
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      },
    );
    setItems1(response.data);
    setSimpleSelectErr("");
  };

  const handleSimple1 = async (event) => {
    // setSimpleSelect(event.target.value);
    const { value } = event.target;
    const itemm = items1.find((itemm) => itemm.id == value);
    setSimpleSelect1(value);
    setGetcatId(itemm.id);
    setSimpleSelect1Err("");

    const categoryApi = inshaApi + `/category/list/byAdminId/2`;
    const categoryRresult = await fetch(categoryApi);
    const getAllCategory = await categoryRresult.json();
    // console.log(getAllCategory);

    const itemCat = items.find((item) => item.id == simpleSelect);
    // console.log("Category ", itemCat);

    const filteredData = getAllCategory.filter(
      (cat) =>
        cat.title?.trim().toLowerCase() === itemCat.title?.trim().toLowerCase(),
    )[0];
    // console.log("Parent ", filteredData && filteredData.parent);

    const parentApi = inshaApi + `/parent/list/byCategoryId/${filteredData.id}`;
    const parentRresult = await fetch(parentApi);
    const getAllParent = await parentRresult.json();

    const filteredDataParent = getAllParent.filter(
      (p) =>
        p.title?.trim().toLowerCase() === itemm.title?.trim().toLowerCase(),
    )[0];
    // console.log("Parent ", filteredDataParent && filteredDataParent);

    const childApi =
      inshaApi + `/child/list/byParentId/${filteredDataParent.id}`;
    const childRresult = await fetch(childApi);
    const getAllChild = await childRresult.json();

    // const filteredParentData = filteredData && filteredData.parent.filter((p) => p.title?.trim().toLowerCase() === itemm.title?.trim().toLowerCase())[0];
    // if (filteredParentData && filteredParentData.child) {
    //   // sort by id ascending
    //   filteredParentData.child.sort((a, b) => a.id - b.id);
    // }
    // console.log("Child ", filteredParentData && filteredParentData.child);

    setItems2(getAllChild);
  };

  const handleMultiple = (event) => {
    // setMultipleSelect(event.target.value);
    setMultipleSelectErr("");

    const value = event.target.value;

    // Handle Select All
    if (value[value.length - 1] === "all") {
      if (multipleSelect.length === items2.length) {
        // Deselect all
        setMultipleSelect([]);
      } else {
        // Select all
        setMultipleSelect(items2);
      }
      return;
    }

    setMultipleSelect(value);
  };

  const isAllSelected =
    items2.length > 0 && multipleSelect.length === items2.length;

  const handleLabour = (index) => (e) => {
    let title = e.target.value;
    setMultipleSelect((curlab) =>
      produce(curlab, (v) => {
        v[index].title = title;
      }),
    );
  };

  const handleHSNCode = (index) => (e) => {
    let hsncode = e.target.value;
    setMultipleSelect((curlab) =>
      produce(curlab, (v) => {
        v[index].hsncode = hsncode;
      }),
    );
  };

  const handlePrice = (index) => (e) => {
    let price = e.target.value;
    setMultipleSelect((curlab) =>
      produce(curlab, (v) => {
        v[index].price = price;
      }),
    );
  };

  const handleGst = (index) => (e) => {
    let taxPercentage = e.target.value;
    setMultipleSelect((curlab) =>
      produce(curlab, (v) => {
        v[index].taxPercentage = taxPercentage;
      }),
    );
  };

  const SubmitAddLabourRate = (e) => {
    setNewChild(true);
    let errorCount = 0;
    if (simpleSelect === "" || !simpleSelect) {
      errorCount++;
      setSimpleSelectErr("Select Category");
    }
    if (simpleSelect1 === "" || !simpleSelect1) {
      errorCount++;
      setSimpleSelect1Err("Select Product Size MM");
    }
    if (labourDetails === "" || !labourDetails) {
      errorCount++;
      setLabourErr("This Labour Title Field Required");
    }
    if (hsnCode === "" || !hsnCode) {
      errorCount++;
      setHsnCodeErr("This HSN Code Field Required");
    }
    if (price === "" || !price) {
      errorCount++;
      setPriceErr("This Price Field Required");
    }
    if (gst === "" || !gst) {
      errorCount++;
      setGstErr("This GST 5% Field Required");
    }

    if (errorCount === 0) {
      setBtn(true);
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Basic ${credentials}`,
        },
        body: JSON.stringify({
          title: labourDetails,
          hsncode: hsnCode,
          price: price,
          taxPercentage: gst,
        }),
      };
      fetch(localApi + `/child/add/ByParentId/${getcatId}`, requestOptions)
        .then((res) => res.json())
        .then((data) => {
          // console.log(data);
          if (data.error == true) {
            alertTypeOps("success");
            alertMsgOps("Succesfully !!!");
            setSubmitted(true);
          } else {
            alertTypeOps("danger");
            alertMsgOps("Already Exits");
            setSubmitted(true);
          }
        });
    }
  };

  const SubmitAddDefaultCategorySize = (e) => {
    setNewDefChild(true);
    let errorCount = 0;
    if (simpleSelect === "" || !simpleSelect) {
      errorCount++;
      setSimpleSelectErr("Select Category");
    }
    if (simpleSelect1 === "" || !simpleSelect1) {
      errorCount++;
      setSimpleSelect1Err("Select Product Size MM");
    }
    if (!Array.isArray(multipleSelect) || multipleSelect.length < 2) {
      errorCount++;
      setMultipleSelectErr("Select at least two product Labour & Rate");
    }
    if (errorCount === 0) {
      // console.log(simpleSelect);
      // console.log(simpleSelect1);
      // console.log(getcatId);

      // console.log(multipleSelect.map((m) => {
      //   return {
      //     title: m.title,
      //     hsncode: m.hsncode,
      //     price: parseFloat(m.price) || 0,
      //     taxPercentage: parseFloat(m.taxPercentage) || 0,
      //   }
      // }));

      setBtn(true);
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Basic ${credentials}`,
        },
        body: JSON.stringify(
          multipleSelect.map((m) => {
            return {
              title: m.title,
              hsncode: m.hsncode,
              price: parseFloat(m.price) || 0,
              taxPercentage: parseFloat(m.taxPercentage) || 0,
            };
          }),
        ),
      };
      fetch(localApi + `/child/addAll/byParentId/${getcatId}`, requestOptions)
        .then((res) => res.json())
        .then((data) => {
          // console.log(data);
          if (data.message === "Data Inserted Successfully !!!") {
            alertTypeOps("success");
            alertMsgOps("Succesfully !!!");
            setSubmitted(true);
          } else {
            alertTypeOps("danger");
            alertMsgOps("Already Exits");
            setSubmitted(true);
          }
        });
    }
  };

  const hideAlert = () => {
    setSubmitted(false);
    window.location.reload(false);
  };

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false; // skip first render
      return;
    }
    // console.log("Value Changed")
    setActive(false);
    // setSimpleSelect1("");
    setMultipleSelect([]);
  }, [simpleSelect1]);

  return (
    <div>
      <GridContainer justify="center" alignItems="center">
        <GridItem
          xs={12}
          sm={active === true ? 12 : 12}
          md={active === true ? 12 : 6}
        >
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <AddIcon />
              </CardIcon>
              <h3 className={classes.cardIconTitle}>
                <small>Add Labour & Rate</small>
                {active === true ? (
                  newDefChild === true ? (
                    <small
                      style={{
                        fontSize: "12px",
                        color: "red",
                        marginLeft: "10px",
                      }}
                    >
                      {simpleSelectErr || simpleSelect1Err || multipleSelectErr}
                    </small>
                  ) : (
                    <small style={{ fontSize: "12px", marginLeft: "10px" }}>
                      Select Category
                    </small>
                  )
                ) : newChild === true ? (
                  <small
                    style={{
                      fontSize: "12px",
                      color: "red",
                      marginLeft: "10px",
                    }}
                  >
                    {simpleSelectErr ||
                      simpleSelect1Err ||
                      labourErr ||
                      hsnCodeErr ||
                      priceErr ||
                      gstErr}
                  </small>
                ) : (
                  <small style={{ fontSize: "12px", marginLeft: "10px" }}>
                    Select Category
                  </small>
                )}
              </h3>
            </CardHeader>
            <CardBody>
              <GridContainer justify="center" alignItems="center">
                {submitted ? (
                  <SweetAlert
                    type={alertType}
                    style={{ display: "block", marginTop: "-100px" }}
                    title={alertMsg}
                    onConfirm={() => hideAlert()}
                    confirmBtnCssClass={
                      classSweet.button + " " + classSweet.success
                    }
                  >
                    Added Labour & Rate
                  </SweetAlert>
                ) : null}{" "}
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth className={classe.selectFormControl}>
                    <InputLabel
                      htmlFor="simple-select"
                      className={classe.selectLabel}
                    >
                      Select Category Title...
                    </InputLabel>

                    <Select
                      MenuProps={{
                        className: classe.selectMenu,
                      }}
                      classes={{
                        select: classe.select,
                      }}
                      value={simpleSelect}
                      onChange={handleSimple}
                      inputProps={{
                        name: "simpleSelect",
                        id: "simple-select",
                      }}
                    >
                      <MenuItem
                        disabled
                        classes={{
                          root: classe.selectMenuItem,
                        }}
                      >
                        Select Category Title...
                      </MenuItem>
                      {items &&
                        items.map((item) => (
                          <MenuItem
                            key={item.id}
                            value={item.id}
                            classes={{
                              root: classe.selectMenuItem,
                              selected: classe.selectMenuItemSelected,
                            }}
                          >
                            {item.title}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </GridItem>{" "}
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth className={classe.selectFormControl}>
                    <InputLabel
                      htmlFor="simple-select"
                      className={classe.selectLabel}
                    >
                      Select Product Size-MM...
                    </InputLabel>

                    <Select
                      MenuProps={{
                        className: classe.selectMenu,
                      }}
                      classes={{
                        select: classe.select,
                      }}
                      value={simpleSelect1}
                      onChange={handleSimple1}
                      inputProps={{
                        name: "simpleSelect",
                        id: "simple-select",
                      }}
                    >
                      <MenuItem
                        disabled
                        classes={{
                          root: classe.selectMenuItem,
                        }}
                      >
                        Select Product Size-MM...
                      </MenuItem>
                      {items1 &&
                        items1.map((item1) => (
                          <MenuItem
                            key={item1.id}
                            value={item1.id}
                            classes={{
                              root: classe.selectMenuItem,
                              selected: classe.selectMenuItemSelected,
                            }}
                          >
                            {item1.title}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </GridItem>{" "}
                {active === false ? (
                  <>
                    <GridItem xs={12} sm={6} md={6}>
                      <CustomInput
                        labelText="Labour Title..."
                        id="labourDetails"
                        inputProps={{
                          placeholder: "Ex. Cutting...",
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="labourDetails"
                        value={labourDetails}
                        onChange={(e) => {
                          setLabourDetails(e.target.value);
                          setLabourErr("");
                        }}
                        required={true}
                      />
                      {/* <span style={{ color: "red" }}>{labourErr}</span> */}
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <CustomInput
                        labelText="HSN Code..."
                        id="hsnCode"
                        inputProps={{
                          placeholder: "Ex. 998893...",
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="hsnCode"
                        value={hsnCode}
                        onChange={(e) => {
                          setHsnCode(e.target.value);
                          setHsnCodeErr("");
                        }}
                        required={true}
                      />
                      {/* <span style={{ color: "red" }}>{hsnCodeErr}</span> */}
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <CustomInput
                        labelText="Price..."
                        id="price"
                        inputProps={{
                          placeholder: "Ex. 1.50...",
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="price"
                        value={price}
                        onChange={(e) => {
                          setPrice(e.target.value);
                          setPriceErr("");
                        }}
                        required={true}
                      />
                      {/* <span style={{ color: "red" }}>{priceErr}</span> */}
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <CustomInput
                        labelText="Tax Rate..."
                        id="gst"
                        inputProps={{
                          placeholder: "Ex. 5...",
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="gst"
                        value={gst}
                        onChange={(e) => {
                          setGst(e.target.value);
                          setGstErr("");
                        }}
                        required={true}
                      />
                      {/* <span style={{ color: "red" }}>{gstErr}</span> */}
                    </GridItem>{" "}
                  </>
                ) : (
                  ""
                )}
                <GridItem xs={12} sm={12} md={12}>
                  <FormControlLabel
                    classes={{
                      root: classCheck.checkboxLabelControl,
                      label: classCheck.checkboxLabel,
                    }}
                    control={
                      <Checkbox
                        id="active"
                        value={active}
                        checked={active & (active === true) ? active : active}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setActive(checked);
                          if (!checked) {
                            // If checkbox is unchecked, clear multipleSelect
                            setMultipleSelect([]);
                            setMultipleSelectErr(""); // Also clear any errors if needed
                          }
                        }}
                        tabIndex={-1}
                        checkedIcon={
                          <Check className={classCheck.checkedIcon} />
                        }
                        icon={<Check className={classCheck.uncheckedIcon} />}
                        classes={{
                          checked: classCheck.checked,
                          root: classCheck.checkRoot,
                        }}
                      />
                    }
                    label={
                      <span style={{ color: "#9c27b0" }}>
                        Would you like to save the default Labour & Rate?
                      </span>
                    }
                  />
                </GridItem>
                {active === true ? (
                  <GridItem xs={12} sm={12} md={12}>
                    <FormControl fullWidth className={classe.selectFormControl}>
                      <InputLabel
                        htmlFor="multiple-select"
                        className={classe.selectLabel}
                      >
                        Select Labour & Rate...
                      </InputLabel>
                      <Select
                        multiple
                        value={multipleSelect}
                        onChange={handleMultiple}
                        MenuProps={{ className: classe.selectMenu }}
                        classes={{ select: classe.select }}
                        inputProps={{
                          name: "multipleSelect",
                          id: "multiple-select",
                        }}
                        renderValue={(selected) =>
                          selected
                            .map((s) => `${s.title} > ${s.price}`)
                            .join(", ")
                        }
                      >
                        {/* Disabled placeholder */}
                        <MenuItem
                          disabled
                          classes={{ root: classe.selectMenuItem }}
                        >
                          Select Labour & Rate...
                        </MenuItem>

                        {/* ✅ Select All option */}
                        {simpleSelect1 && (
                          <MenuItem value="all">
                            <Checkbox checked={isAllSelected} />
                            <ListItemText primary="Select All" />
                          </MenuItem>
                        )}

                        {/* ✅ Individual items */}
                        {items2 &&
                          items2.map((item2) => (
                            <MenuItem
                              key={item2.id}
                              value={item2}
                              classes={{
                                root: classe.selectMenuItem,
                                selected: classe.selectMenuItemSelectedMultiple,
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <Checkbox
                                checked={multipleSelect.some(
                                  (s) => s.id === item2.id,
                                )}
                              />
                              <ListItemText
                                primary={`${item2.title} > ${item2.price}`}
                              />
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </GridItem>
                ) : (
                  ""
                )}
              </GridContainer>
              <GridContainer>
                {multipleSelect &&
                  multipleSelect.map((Ele, index) => (
                    <GridItem xs={12} sm={6} md={4} key={Ele.id} value={Ele.id}>
                      <Card>
                        <CardBody>
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                              <CustomInput
                                labelText={"Labour Title..." + Ele.id}
                                id="labourDetails"
                                inputProps={{
                                  placeholder: "Ex. Cutting...",
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                name="labourDetails"
                                value={Ele.title}
                                onChange={handleLabour(index)}
                              />
                            </GridItem>

                            <GridItem xs={4} sm={4} md={4}>
                              <CustomInput
                                labelText="HSN Code"
                                id="hsncode"
                                inputProps={{
                                  placeholder: "HSN Code...",
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                name="hsncode"
                                value={Ele.hsncode}
                                onChange={handleHSNCode(index)}
                              />
                            </GridItem>
                            <GridItem xs={4} sm={4} md={4}>
                              <CustomInput
                                labelText="Price"
                                id="price"
                                inputProps={{
                                  placeholder: "Price...",
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                name="price"
                                value={Ele.price}
                                onChange={handlePrice(index)}
                              />
                            </GridItem>
                            <GridItem xs={4} sm={4} md={4}>
                              <CustomInput
                                labelText="Tax Rate"
                                id="gst"
                                inputProps={{
                                  placeholder: "Ex. 5...",
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                name="gst"
                                value={Ele.taxPercentage}
                                onChange={handleGst(index)}
                              />
                            </GridItem>
                          </GridContainer>
                        </CardBody>
                      </Card>
                    </GridItem>
                  ))}
              </GridContainer>
              {/* <Button
                color="rose"
                onClick={SubmitAddLabourRate}
                className={classes.updateProfileButton}
              >
                Save
              </Button> */}
              {btn === true ? (
                <Button className={classes.updateProfileButton}>Save</Button>
              ) : active === true ? (
                <Button
                  color="rose"
                  onClick={SubmitAddDefaultCategorySize}
                  className={classes.updateProfileButton}
                >
                  Save Default
                </Button>
              ) : (
                <Button
                  color="rose"
                  onClick={SubmitAddLabourRate}
                  className={classes.updateProfileButton}
                >
                  Save
                </Button>
              )}
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
